module.exports = __webpack_public_path__ + "components/flag/static/square/cefta-c3dd8125abcd8b7abad6b8b85ce79e6d.svg";